<template>
  <v-card class="user-history" tile>
    <v-card-title>{{ this.$t('statistics.queue') }}</v-card-title>
    <div class="pa-2 pl-4">
      <dl class="form-box">
        <dt class="d-table-cell pt-1">{{ this.$t('statistics.category') }}</dt>
        <dd class="d-table-cell">
          <div class="d-flex align-content-start flex-wrap">
            <span class="wrap-sts-chk">
              <v-checkbox v-model="queueTypesVmAll" @click="toggleAll" :label="$t('statistics.queue.checkAll')" class="sts-comp-chk-mgt-2" hide-details dense></v-checkbox>
            </span>
          </div>
          <div class="d-flex align-content-start flex-wrap">
            <span class="wrap-sts-chk" v-for="(item, idx) in options" :key="idx">
              <v-checkbox v-model="queueVm" :label="item.text" :value="item.value" class="sts-comp-chk-mgt-2" hide-details dense></v-checkbox>
            </span>
          </div>
        </dd>
      </dl>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    options: Array,
  },
  data() {
    return {
      queueTypesVmAll: false,
      queueVm: [],
    };
  },
  watch: {
    queueVm(val) {
      const returnVal = {
        val: Object.values(val).length > 1 ? Object.values(val).join() : val,
        title: this.$t('statistics.queue'),
      };
      this.$emit('changeQueue', { ...returnVal }, 'queue');
      this.queueTypesVmAll = this.options.length === val.length ? true : false;
    },
  },
  created() {
    this.allCheck();
  },
  methods: {
    allCheck() {
      this.queueVm = [];
      this.options.map(el => this.queueVm.push(el.value));
    },
    toggleAll() {
      !this.queueTypesVmAll ? (this.queueVm = []) : this.allCheck();
    },
  },
};
</script>
